import { DOCUMENT } from '@angular/common';
import { Component, OnInit, effect, inject, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ToastHostComponent, SpinnerComponent } from '@jdi/jdi-ui-kit';
import { startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AuthSessionService } from './core/auth/services/auth-session.service';
import { ToastService } from './core/services/toast.service';

const APP_BOOTSTRAP_BODY_CLASS = 'shipments-startup-overlay-open';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastHostComponent, SpinnerComponent],
  templateUrl: './app.html'
})
export class App implements OnInit {
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);
  protected readonly showShipmentsStartupOverlay = signal(
    this.isShipmentsUrl(this.router.url)
  );

  constructor(
    private readonly authSessionService: AuthSessionService,
    protected readonly toastService: ToastService
  ) {
    effect(() => {
      this.document.body?.classList.toggle(
        APP_BOOTSTRAP_BODY_CLASS,
        this.showShipmentsStartupOverlay()
      );
      this.document.documentElement?.classList.toggle(
        APP_BOOTSTRAP_BODY_CLASS,
        this.showShipmentsStartupOverlay()
      );
    });

    this.router.events
      .pipe(startWith(null), takeUntilDestroyed())
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.showShipmentsStartupOverlay.set(
            this.isShipmentsUrl(event.url)
          );
          return;
        }

        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.showShipmentsStartupOverlay.set(false);
          return;
        }

        if (event === null) {
          this.showShipmentsStartupOverlay.set(
            this.isShipmentsUrl(this.router.url)
          );
        }
      });
  }

  ngOnInit(): void {
    void this.authSessionService.initialize();
  }

  private isShipmentsUrl(url: string): boolean {
    const path = url.split(/[?#]/, 1)[0];

    return /^\/(?:shipments|expedition)(?:\/|$)/i.test(path);
  }
}
